module.exports = __webpack_public_path__ + "static/media/button-logout.7528c1b7.png";